import { GrowColumn, PageContent } from "pages/styles";
import { shallowEqual } from "react-redux";
import { MaxWidth } from "styles/layout";
import { Panel } from "components/Panel/Panel";
import { PanelLoadingSpinner } from "components/Panel/styles";
import { ReactNode, useEffect } from "react";
import {
  selectAllTrackedTracksLoaded,
  selectTracksNotTracked,
} from "selectors/TournamentLoading";
import { onlyUnique } from "Utility";
import { trackTracks, updateTrack } from "app/slices/TrackSlice";
import { selectTournamentTrackIds } from "selectors/Tournament";
import { trackCollectionName } from "db/info/collectionNames";
import { mapTrack } from "db/mapping/track/FsTrack";
import { startTracking } from "app/TrackingSlice";
import { useAppDispatch, useAppSelector } from "app/hooks";

interface Props {
  children: ReactNode;
  tournamentIds: string[];
}
export const TrackLoader = ({ children, tournamentIds }: Props) => {
  const dispatch = useAppDispatch();

  // todo - maybe memoised selector is better?
  const tournamentTrackIds = useAppSelector(
    (state) =>
      tournamentIds
        .flatMap((id) => selectTournamentTrackIds(state, id) ?? [])
        .filter(onlyUnique),
    shallowEqual
  );

  const tracksToTrack = useAppSelector(
    (state) => selectTracksNotTracked(state, tournamentTrackIds),
    shallowEqual
  );

  const tracksLoaded = useAppSelector(selectAllTrackedTracksLoaded);

  useEffect(() => {
    if (tracksToTrack.length > 0) {
      startTracking(
        tracksToTrack,
        trackCollectionName,
        mapTrack,
        dispatch,
        trackTracks,
        updateTrack
      );
    }
  }, [tracksToTrack]);

  if (!tracksLoaded) {
    return (
      <PageContent>
        <MaxWidth>
          <GrowColumn>
            <Panel>
              <PanelLoadingSpinner />
            </Panel>
          </GrowColumn>
        </MaxWidth>
      </PageContent>
    );
  }

  return <>{children}</>;
};
